import { render, staticRenderFns } from "./supplierSelect.vue?vue&type=template&id=6b993bfa&scoped=true"
import script from "./supplierSelect.vue?vue&type=script&lang=js"
export * from "./supplierSelect.vue?vue&type=script&lang=js"
import style0 from "./supplierSelect.vue?vue&type=style&index=0&id=6b993bfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b993bfa",
  null
  
)

export default component.exports